/**
 * Centralized font size constants
 * Use with useFontScale(): fontSize={FS_MD * fontScale}
 */

export const FS_XS = 12;
export const FS_SM = 14;
export const FS_MD = 16;
export const FS_LG = 18;
export const FS_XL = 20;
export const FS_2XL = 24;
export const FS_3XL = 30;
export const FS_4XL = 36;
